import React from 'react';
import FilaTablaPartidos from './FilaTablaPartidos';
import { AnimatePresence, motion } from 'framer-motion';
import { useEleccion } from '../../contexts/eleccionContext';
import styled from 'styled-components/macro';

const TablaPartidos = props => {
  const { idEleccion } = useEleccion();
  const getPartidos = (camaraSeleccionada, soloConCargo) => {
    let partidos = [];
    partidos = camaraSeleccionada.partotabla;
    if (soloConCargo) {
      partidos = partidos && partidos.filter(x => x.act.carg > 0);
    }
    return partidos;
  };
  const veirfySecondElecction = !!props.bogota;
  const parto = getPartidos(props.camaraSeleccionada, props.soloConCargo);
  return (
    <>
      {parto && parto.length > 0 && (
        <AnimatePresence>
          {!props.animating && (
            <Ul
              transition={{
                staggerChildren: 0.1,
              }}
              initial="hide"
              exit="hide"
              animate="show"
            >
              <AnimatePresence>
                {parto.map((partido, index) => {
                  return veirfySecondElecction && index === 0 ? (
                    <motion.li
                      key={partido.act.codpar}
                      style={{
                        marginLeft: 'auto',
                      }}
                      transition={{
                        duration: 0.2,
                      }}
                      variants={{
                        show: { opacity: 1, translateX: 0 },
                        hide: { opacity: 0, translateX: 50 },
                      }}
                    >
                      <FilaTablaPartidos
                        primeroBogota={props.bogota}
                        mostrarVotos={props.mostrarVotos}
                        partido={partido}
                        soloConCargo={props.soloConCargo}
                        mostrarCargos={props.mostrarCargos}
                        mostrarCandidatos={props.mostrarCandidatos}
                        isUnicandidato={props.isUnicandidato}
                      />
                    </motion.li>
                  ) : (
                    <motion.li
                      key={partido.act.codpar}
                      style={{
                        marginLeft: 'auto',
                      }}
                      transition={{
                        duration: 0.2,
                      }}
                      variants={{
                        show: { opacity: 1, translateX: 0 },
                        hide: { opacity: 0, translateX: 50 },
                      }}
                    >
                      <FilaTablaPartidos
                        mostrarVotos={props.mostrarVotos}
                        partido={partido}
                        soloConCargo={props.soloConCargo}
                        mostrarCargos={props.mostrarCargos}
                        mostrarCandidatos={props.mostrarCandidatos}
                        isUnicandidato={props.isUnicandidato}
                      />
                    </motion.li>
                  );
                })}
              </AnimatePresence>
            </Ul>
          )}
        </AnimatePresence>
      )}
      {parto === undefined || (parto.length === 0 && <div>No hay datos</div>)}
    </>
  );
};

const Ul = styled(motion.ul)`
  overflow-x: hidden;
`;

export default TablaPartidos;
